import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {
  InMemoryScrollingFeature,
  InMemoryScrollingOptions,
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideEnvironmentNgxMask } from "ngx-mask";
import { routes } from './app.routes';
import { HttpClient, provideHttpClient, withInterceptors } from "@angular/common/http";
import { sessionInterceptor } from './partials/interceptors/session.interceptor';
import { unauthorizedInterceptor } from './partials/interceptors/unauthorized.interceptor';
import { errorInterceptor } from './partials/interceptors/error.interceptor';
import { dialogOptions, dialogOptionsData, dialogOptionsRef, snackBarOptions } from './partials/mat-options';
import { appConfigInit } from './app-config-init';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DEFAULT_LANGUAGE } from "./partials/variables";

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    provideEnvironmentNgxMask(),
    provideRouter(routes, withComponentInputBinding(), inMemoryScrollingFeature),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => {
            return new TranslateHttpLoader(http, './assets/i18/', '.json');
          },
          deps: [HttpClient],
        },
        isolate: true,
        defaultLanguage: DEFAULT_LANGUAGE
      })
    ),
    provideHttpClient(withInterceptors([sessionInterceptor, unauthorizedInterceptor, errorInterceptor])),
    appConfigInit,
    snackBarOptions,
    dialogOptions,
    dialogOptionsData,
    dialogOptionsRef
  ]
};
